import { MemberInfo } from "../../types/member";

import { safeReplaceAll } from "../../libs/replace";

export const formattingMemberInfo = (memberInfo: MemberInfo) => {
  return {
    ...memberInfo,
    createdAt: safeReplaceAll(memberInfo.createdAt, "/", "-"),
    lastLoggedAt: safeReplaceAll(memberInfo.lastLoggedAt, "/", "-"),
  };
};

export default function useShowQualtrics({
  open,
}: {
  open?: (message: string) => void;
}): [(interceptId: string, memberInfo: MemberInfo) => void] {
  const showQualtrics = function (interceptId: string, memberInfo: MemberInfo) {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    const formattedMemberInfo = formattingMemberInfo(memberInfo);

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.showQualtricsIntercept) {
        window.SANDI.showQualtricsIntercept(
          interceptId,
          JSON.stringify(formattedMemberInfo)
        );
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      if (
        window?.webkit?.messageHandlers?.showQualtricsIntercept?.postMessage
      ) {
        window.webkit?.messageHandlers.showQualtricsIntercept.postMessage(
          JSON.stringify({ interceptId, ...formattedMemberInfo })
        );
      }
    } else {
      open?.("모바일 기기에서 시도해주세요.");
    }
  };

  return [showQualtrics];
}
